var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "400px",
    height: "400px",
    viewBox: "0 0 400 400",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logo 400x400 (Twitter)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo-400x400-(Twitter)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(13.000000, -14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-7",
    fill: "#72CAFF",
    x: 15.4004409,
    y: 16.5117301,
    width: 80.9953328,
    height: 396.905983,
    rx: 40.4976664
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-7",
    fill: "#51B7F5",
    x: 276.604226,
    y: 16.4934496,
    width: 80.9953328,
    height: 396.905983,
    rx: 40.4976664
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-7",
    fill: "#51B7F5",
    transform: "translate(122.813510, 214.000000) scale(-1, 1) rotate(23.000000) translate(-122.813510, -214.000000) ",
    x: 82.3158433,
    y: 2.74358974,
    width: 80.9953328,
    height: 422.512821,
    rx: 40.4976664
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-7",
    fill: "#72CAFF",
    transform: "translate(253.412432, 214.261613) rotate(22.000000) translate(-253.412432, -214.261613) ",
    x: 212.914766,
    y: 3.54030518,
    width: 80.9953328,
    height: 421.442615,
    rx: 40.4976664
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.f05869138bdb68e26e5264e2f65656e8.svg";
export { ForwardRef as ReactComponent };